<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Einstellungen</h1>

    <!-- loadOnDemand: a tab is rendered when first opened and then kept, so what was typed
         into one tab survives a look at another. -->
    @if (profile) {
      <kendo-tabstrip class="mt-3" keepTabContent="loadOnDemand">
        @if (showSystemTab) {
          <kendo-tabstrip-tab title="System" i18n-title [selected]="showSystemTab" cssClass="settings-tab-system">
            <ng-template kendoTabContent>
              <app-printer-settings></app-printer-settings>
            </ng-template>
          </kendo-tabstrip-tab>
        }

        @if (isAdmin) {
          <kendo-tabstrip-tab title="Benachrichtigungen" i18n-title cssClass="settings-tab-notifications">
            <ng-template kendoTabContent>
              <app-notification-settings></app-notification-settings>
            </ng-template>
          </kendo-tabstrip-tab>
        }

        <kendo-tabstrip-tab title="Benutzer" i18n-title [selected]="!showSystemTab" cssClass="settings-tab-user">
          <ng-template kendoTabContent>
            <app-user-settings></app-user-settings>
            <app-personalization-settings></app-personalization-settings>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    }

    <div class="mt-3">
      <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>
        Zurück
      </button>
    </div>
  </div>
</div>
